<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLiveStream_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.318 4.5h13.364c2.11 0 3.818 1.807 3.818 4.038v8.077c0 2.232-1.709 4.039-3.818 4.039H5.318c-2.11 0-3.818-1.807-3.818-4.039V8.538C1.5 6.308 3.209 4.5 5.318 4.5m11.358 8.92a.75.75 0 0 0 0-1.34l-6.587-3.327A.75.75 0 0 0 9 9.423v6.655a.75.75 0 0 0 1.088.67z"
        clip-rule="evenodd"
    />
</svg>
